/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import React from 'react';
import PlaceholderLoading from 'react-placeholder-loading';
import { Container, Col, Row } from 'react-bootstrap';
import * as S from './styles';

export const PlaceHolderComp = () => {
  let _placeholders: any = [];

  for (let i = 0; i < 9; i++) {
    _placeholders.push(
      <Col xs={12} lg={4} md={4} sm={6}>
        <S.PlaceHolderContainer>
          <PlaceholderLoading shape="rect" width={60} height={60} />
          <div className="px-4">
            <PlaceholderLoading shape="rect" width={'100%'} height={12} />
            <PlaceholderLoading shape="rect" width={'70%'} height={12} />
            <PlaceholderLoading shape="rect" width={'50%'} height={9} />
          </div>
        </S.PlaceHolderContainer>
      </Col>
    );
  }
  return (
    <Container fluid>
      <Row>{_placeholders}</Row>
    </Container>
  );
};
